export const getStoreEmployeeListQuery = `
 query GetStoreEmployeeList($input: ListStoreUsersInput!) {
      listStoreUsers(input: $input) {
        code
        users {
            id
            firstName
            lastName
            email
            phone
            profileImage
            accountStatus
            role
        }
    }
 }
`;

export const getCompanyEmployeeListQuery = `
 query GetCompanyEmployeeList($input: ListCompanyUsersInput!) {
      listCompanyUsers(input: $input) {
        code
        users {
            id
            firstName
            lastName
            email
            phone
            profileImage
            role
            storeId
            companyId
            emailVerified
        }
    }
 }
`;

export const createEmployeeQuery = `
 mutation CreateEmployee($input: CreateUserInput!) {
    createUser(input: $input) {
        code
        user {
            id
            firstName
            lastName
            email
            phone
            profileImage
            role
            companyId
            storeId
            emailVerified
            passwordChangeRequired
        }
    }
 }
`;

export const getEmployeeDetailQuery = `
 query GetEmployeeDetail($input: GetUserInput!) {
      getUser(input: $input) {
        user {
            id
            firstName
            lastName
            email
            phone
            profileImage
            role
            companyId
            storeId
            emailVerified
            passwordChangeRequired
        }
        code
    }
 }
`;

export const updateEmployeeQuery = `
 mutation UpdateEmployee($input: UpdateUserInput!) {
      updateUser(input: $input) {
           code
            user {
                id
                firstName
                lastName
                email
                phone
                profileImage
                role
                companyId
                storeId
                emailVerified
                passwordChangeRequired
            }
    }
 }
`;

export const deleteEmployeeQuery = `
 mutation deleteUser($input: DeleteUserInput!) {
      deleteUser(input: $input) {
           code
            
    }
 }
`;
